import { defineMessages } from 'react-intl';

import type { OpportunityStatusFilterValueKey } from '../../../../../common/constants/filters/opportunity-status-filter';

export const opportunityStatusLabels: Record<
	'all' | OpportunityStatusFilterValueKey,
	import('react-intl').MessageDescriptor
> = defineMessages<OpportunityStatusFilterValueKey | 'all'>({
	all: {
		id: 'search-page.filter.opportunityStatus.all',
		defaultMessage: 'Any',
		description: 'Any opportunity status (no filter applied)',
	},
	open: {
		id: 'search-page.filter.opportunityStatus.open',
		defaultMessage: 'Open',
		description:
			'Drop-down item label for the Open value in the Opportunity Status filter on the search page.',
	},
	closed: {
		id: 'search-page.filter.opportunityStatus.closed',
		defaultMessage: 'Closed',
		description:
			'Drop-down item label for the Closed value in the Opportunity Status filter on the search page.',
	},
});
